import Cookies from 'js-cookie';

export const getAuthToken = () => {

    let token = Cookies.get('ap_auth_token');
    if (token === "") {
        return null;
    } else if (token === undefined || token === "undefined") {
        return null;
    } else {
        return token;
    }
}

export const appURL = "https://www.hisabat.om/be-service";
export const appURLFE = "https://www.hisabat.om/registration";
export const appURLWS = "https://www.hisabat.om/be-service-ws/ws";
export const appURLUpload = "https://hisabatdev.bytmatrx.com/be-service-sch";
export const hostname = "www.hisabat.om";
export const hostname_1 = "admin.hisabat.om";
export const hostname_2 = "partner.hisabat.om";
export const VAPID_PUBLIC_KEY = 'BCcnJbcqMDAa-MeSqtEWT6pjWpMuUfcREc4BleFmHBv6bO3YaCAG-MvBc3_amhBia-A55vzaKZx9i6c2y44SLdU';